import { useGetApplicationDetailsQueryState, useGetScholarsApplicationDetailsQueryState } from "../../services/graphql/api";
import { getApplDetailParams } from "../../util/functions";

// has503 — Route-aware applicant-details query state. The Scholars applicant page uses a separate
// query (getScholarsApplicationDetails); Honors uses getApplicationDetails. Section components that
// read applicant details directly should use this hook so they work on both pages. Both underlying
// hooks are called unconditionally (rules of hooks); we return the one matching the current route.
// getApplDetailParams already resolves the Scholars URL shape (/scholars/applicant/:id/:term), so the
// cache key matches what ScholarsApplicant dispatched with.
export function useApplicantDetailsState() {
    const isScholars = typeof window !== "undefined" && window.location.pathname.includes("/scholars/applicant");
    const params = getApplDetailParams();

    const honorsState = useGetApplicationDetailsQueryState(params);
    const scholarsState = useGetScholarsApplicationDetailsQueryState(params);

    return isScholars ? scholarsState : honorsState;
}
